import { PluginsConsolePage } from "../../operator/console/plugins-console";

export default function ConsolePluginsRoute() {
  return <PluginsConsolePage />;
}
